import { Legend } from "./legend";

/*
 * De officiële klassen van de Leefbaarometer 3.0, op de afwijking van het
 * landelijk gemiddelde (`afw`): de buurtscore (`stats.livability.score`) en
 * de score op het perceel (`rast.Leefbaarometer.afw`). De Leefbaarometer zet
 * zijn klassen op `lbm`, en `afw = lbm − 4,1023` (meting 2024). Grenzen en
 * kleuren uit de WMS-legenda's `score24_*` van geo.leefbaarometer.nl.
 *
 * De backend heeft dezelfde grenzen in `ca_project/integration/livability.py`.
 */

export const LIVABILITY_LEGEND: Legend = [
  { low: -Infinity, name: "Zeer onvoldoende", color: "#CF783F" },
  { low: -0.4283, name: "Ruim onvoldoende", color: "#D7995E" },
  { low: -0.3539, name: "Onvoldoende", color: "#E0B881" },
  { low: -0.2815, name: "Zwak", color: "#FBF2C4" },
  { low: -0.1471, name: "Voldoende", color: "#D0D2A6" },
  { low: -0.1068, name: "Ruim voldoende", color: "#A7B38A" },
  { low: 0.0103, name: "Goed", color: "#819470" },
  { low: 0.0895, name: "Zeer goed", color: "#5E7658" },
  { low: 0.1666, name: "Uitstekend", color: "#3C5941" },
];

/** De bijdrage van een dimensie aan de afwijking. */
export const CONTRIBUTION_LEGEND: Legend = [
  { low: -Infinity, name: "Zeer grote negatieve bijdrage", color: "#D66982" },
  { low: -0.2354, name: "Grote negatieve bijdrage", color: "#DD899A" },
  { low: -0.1568, name: "Negatieve bijdrage", color: "#E5A9B4" },
  { low: -0.0784, name: "Kleine negatieve bijdrage", color: "#F3C9D1" },
  { low: -0.0392, name: "Geen afwijking", color: "#F8FCE3" },
  { low: 0.0392, name: "Kleine positieve bijdrage", color: "#D6DDAF" },
  { low: 0.0784, name: "Positieve bijdrage", color: "#B5BE7E" },
  { low: 0.1568, name: "Grote positieve bijdrage", color: "#96A04A" },
  { low: 0.2355, name: "Zeer grote positieve bijdrage", color: "#798233" },
];

/** De dimensies: sleutel in het raster, sleutel in de buurtstatistiek, label. */
export const DIMENSIONS = [
  { short: "fys", stat: "fysieke_leefomgeving", label: "Fysieke leefomgeving" },
  { short: "onv", stat: "overlast_onveiligheid", label: "Overlast en onveiligheid" },
  { short: "soc", stat: "sociale_samenhang", label: "Sociale samenhang" },
  { short: "vrz", stat: "voorzieningen", label: "Voorzieningen" },
  { short: "won", stat: "woningvoorraad", label: "Woningvoorraad" },
] as const;

/** `rast.Leefbaarometer`: afwijking en dimensies, gemiddeld over het perceel. */
export type ParcelLivability = { afw: number } & Partial<
  Record<(typeof DIMENSIONS)[number]["short"], number>
>;

export const parcelLivability = (
  rast: Record<string, unknown> | undefined
): ParcelLivability | undefined => {
  const value = rast?.Leefbaarometer as ParcelLivability | undefined;
  return typeof value?.afw === "number" ? value : undefined;
};
